export const BEST_PRICE = 'bestPrice'
